import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@design-system/Carousel';
import { DataCard } from '@/components/screens/HomePage/BloodSugarResponsePage/DataCard';
import { useGetPeekIntoData } from '@viome/viome-base/src/usecase/Home/HomeQuery';

export const DataCardsCarousel = ({ scoreId }: { scoreId: number }) => {
  const { data: peekIntoData, isError: peekIntoDataError } =
    useGetPeekIntoData(scoreId);

  if (!peekIntoData || peekIntoDataError || peekIntoData.length === 0) {
    return null;
  }

  return (
    <div className="typography-h1 text-primary mt-8 select-none">
      A Peek into the data
      <div className="mt-8">
        <Carousel
          className="relative w-full"
          opts={{
            align: 'start',
            dragFree: true,
          }}
        >
          <CarouselContent>
            {peekIntoData.map((card, index) => (
              <CarouselItem key={index} className="pl-4 basis-[22rem]">
                <DataCard
                  title={card.title}
                  subtitle={card.subtitle}
                  content={card.content}
                  footnote={card.footnote}
                  source={card.source}
                  link={card.link}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="hidden" />
          <CarouselNext className="hidden" />
        </Carousel>
      </div>
    </div>
  );
};
